import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser]       = useState(null);   // { email, companyName, address }
    const [loading, setLoading] = useState(true);   // checking stored token on mount

    // Re-hydrate session on page load
    useEffect(() => {
        const token = localStorage.getItem('inv_token');
        if (!token) { setLoading(false); return; }
        axios.get('/api/me', { headers: { Authorization: `Bearer ${token}` } })
            .then(r => setUser(r.data.user))
            .catch(() => localStorage.removeItem('inv_token'))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await axios.post('/api/login', { email, password });
        localStorage.setItem('inv_token', data.token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        setUser(data.user);
        return data.user;
    };

    const register = async (email, password, companyName, address) => {
        const { data } = await axios.post('/api/register', { email, password, companyName, address });
        localStorage.setItem('inv_token', data.token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        const token = localStorage.getItem('inv_token');
        if (token) await axios.post('/api/logout', {}, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
        localStorage.removeItem('inv_token');
        delete axios.defaults.headers.common['Authorization'];
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
